import { render, staticRenderFns } from "./commendReq.vue?vue&type=template&id=877a4580&scoped=true&"
import script from "./commendReq.vue?vue&type=script&lang=js&"
export * from "./commendReq.vue?vue&type=script&lang=js&"
import style0 from "./commendReq.vue?vue&type=style&index=0&id=877a4580&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877a4580",
  null
  
)

export default component.exports